import { FC } from "react";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography
} from "@mui/material";
import { ComplianceLifecycle } from "../../../api/Api";

type Props = {
  complianceLifecycle?: ComplianceLifecycle;
};

/**
 * ADHO-453: REMIT reporting is owned by Compliance, but Finance needs to see
 * it. Read-only mirror of the Compliance fields: nothing renders until
 * Compliance picks a value, "Not needed" shows on its own, and "Needed" also
 * surfaces the reporting setup status. The assignee stays in Compliance and is
 * deliberately not mirrored here.
 *
 * Brokers only. REMIT reporting was removed from the counterparty side (it is
 * a broker-only question), so this no longer renders on counterparties.
 */
export const RemitReportingReadOnly: FC<Props> = ({ complianceLifecycle }) => {
  const remitReporting = complianceLifecycle?.remitReporting || "";
  const reportingSetup = complianceLifecycle?.reportingSetup || "";

  if (!remitReporting) {
    return null;
  }

  return (
    <Box display="flex" gap={2}>
      <FormControl disabled size="medium" sx={{ flex: 1 }}>
        <InputLabel>REMIT reporting - filled by Compliance</InputLabel>
        <Select
          label="REMIT reporting - filled by Compliance"
          value={remitReporting}
        >
          <MenuItem value="needed">
            <Typography variant="body1" component="span">
              Needed
            </Typography>
          </MenuItem>
          <MenuItem value="not_needed">
            <Typography variant="body1" component="span">
              Not needed
            </Typography>
          </MenuItem>
        </Select>
      </FormControl>

      {remitReporting === "needed" && (
        <FormControl disabled size="medium" sx={{ flex: 1 }}>
          <InputLabel>Reporting setup - filled by Compliance</InputLabel>
          <Select
            label="Reporting setup - filled by Compliance"
            value={reportingSetup}
          >
            <MenuItem value="initiated">
              <Typography variant="body1" component="span">
                Initiated
              </Typography>
            </MenuItem>
            <MenuItem value="completed">
              <Typography variant="body1" component="span">
                Completed
              </Typography>
            </MenuItem>
            <MenuItem value="not_completed">
              <Typography variant="body1" component="span">
                Not completed
              </Typography>
            </MenuItem>
          </Select>
        </FormControl>
      )}
    </Box>
  );
};
